import PropTypes from "prop-types";

/**
 * Passthrough layout for shared storefront pages on MX mobile.
 * Checkout renders its own MobileTopBar + sticky footer chrome.
 */
export default function MxStorefrontLayout({ children }) {
  return children;
}

MxStorefrontLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
